module.exports = __webpack_public_path__ + "static/media/5.Greavy Machine.2dc8af93.jpg";